import axios from "axios";
const DEV_API_BASE_URL = "http://localhost:8081/api/";
const PROD_API_BASE_URL = "https://happyengine.azurewebsites.net/api/";
const STAGING_API_BASE_URL = "https://happyengine-staging.azurewebsites.net/api/";

const normalizeBaseUrl = (url) => {
  if (!url) {
    return url;
  }
  return url.endsWith('/') ? url : `${url}/`;
};

const isLocalHostname = (hostname) => hostname === 'localhost' || hostname === '127.0.0.1';

const browserHostname = typeof window !== 'undefined' ? window.location.hostname : '';
const runningLocally = isLocalHostname(browserHostname);
const runningInStaging = browserHostname === 'happyenginefront-staging.azurewebsites.net';

const envBaseUrl = normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL || '');
const envPointsToLocal = /localhost|127\.0\.0\.1/i.test(envBaseUrl || '');

// Safety guard: never allow deployed apps to use localhost API URLs.
const baseURL = (() => {
  if (envBaseUrl && (!envPointsToLocal || runningLocally)) {
    return envBaseUrl;
  }

  return runningLocally ? DEV_API_BASE_URL : (runningInStaging ? STAGING_API_BASE_URL : PROD_API_BASE_URL);
})();

export const API_BASE_URL = baseURL;

const json = () => {
  return axios.create({
    baseURL:   baseURL,
    headers: {
      "Content-type": "application/json"
    }
  });
}

const xml = () => {
  return axios.create({
    baseURL:   baseURL,
    crossorigin:true,
    headers: {'Content-Type': 'text/xml'},
  // headers: {"X-API-Key":"8Np5ogHRQV49lih7XEGWd4BFUWx9CCqi9TuTXWmB"},
   //,'X-Requested-With': 'XMLHttpRequest'}
  }); 
}

const types ={
  json,
  xml
}

export default types;

// export default axios.create({
//   baseURL:   baseURL,
//   headers: {
//     "Content-type": "application/json"
//   }
// });



/// "https://happyengine.azurewebsites.net/api/",
// "http://localhost:8080/api/", //